<template>
  <v-container>
    <v-card>
      <v-card-text v-if="loading">
        loading...
      </v-card-text>

      <v-card-text v-else>
        <v-row align='center' justify='center'>
          <v-col cols="12">
            <div class="text-center">
              <v-icon large class='mr-3'>mdi-email-check-outline</v-icon>
              {{ message }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="this.confirmed">
          <v-col class="text-center">
            <v-btn
              x-large
              color='primary'
              class='mr-2 mb-2'
              :to="{
                name: 'orderShow',
                params: {
                  uuid: this.$route.params.order.uuid
                }
              }"
            >
              {{ $t('order.checkin.start') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { utilityMixin } from '../../../mixins/utility_mixin'
import { reservationMixin } from '../../../mixins/reservation_mixin'
import { apartmentMixin } from '../../../mixins/apartment_mixin'
import { guestMixin } from '../../../mixins/guest_mixin'

export default {
  mixins: [
    utilityMixin,
    reservationMixin,
    apartmentMixin,
    guestMixin,
  ],
  data() {
    return {
      loading: true,
      confirmed: false,
    }
  },
  computed: {
    message() {
      if (this.confirmed) {
        return this.$t('order.checkin.existing_account')
      } else {
        return this.$t('order.checkin.missing_account')
      }
    },
  },
  created() {
    const params = {
      order: this.$route.params.order,
      email: this.$route.params.email,
    }

    this.$store.dispatch('profile/createCustomer', params)
      .then(response => {
        this.confirmed = response.data.confirmed
      })
      .catch(error => {
        this.$router.push({ name: 'OrderPublic', params: { uuid: this.$route.params.order.uuid } })
        this.$store.dispatch('layout/addAlert', {
          type: 'error',
          key: 'customer_not_created'
        })
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
